module.exports = __webpack_public_path__ + "img/hero-mobile@3x.e0f5d293.webp";